import businessClient from 'src/services/clients/business'
import { IMeta, IAvailability, IAvailabilityUpsert } from 'src/common/interfaces/index.js'

const ISettingsAvailabilityListResponse = { meta: IMeta, data: { list: [IAvailability] } }

export const settingsAvailability = {
  /**
   * @param {id: number} filter
   * @return {Promise<ISettingsAvailabilityListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('availabilities/portal/list', { filter }, { signal })
  },
  /**
   * @param {IAvailabilityUpsert} data
   * @return {Promise<{upsert: [IAvailability]}>}
   */
  upsert(data, signal) {
    return businessClient().post('availabilities/upsert', { data }, { signal })
  },
  /**
   * @param {store_id: number; id: number} filter
   * @return {Promise<IAvailability>}
   */
  archive(filter, signal) {
    return businessClient().post('availabilities/archive', { filter }, { signal })
  },
}
